import { FC } from 'react';
import { Flex } from '@chakra-ui/react';

import { FooterSection, NavSection } from '../containers/EventPage';

const MAX_WIDTH = '1100px';

export const TEXT_COLOR = '#666';

export const ContainerMaxW = {
  base: '100%',
  md: `calc(${MAX_WIDTH} + 2 * 16px)`,
};

const EventLayout = ({ children }: any) => {
  return (
    <Flex width="100%" justifyContent="center" flexDirection="column">
      <NavSection />
      {children}
      <FooterSection />
    </Flex>
  );
};

export default EventLayout;
